import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";
import { getEnvs } from "state/EnvironmentsContext/EnvContext";
import { ThemingData } from "types/Theming";

export const getThemingData = async (eventId?: string): Promise<ThemingData> => {
  const adminApi = getEnvs((s) => s.admin_api);
  if (!adminApi) {
    throw new Error("Admin API base URL is not configured");
  }
  const baseUrl = adminApi.endsWith("/") ? adminApi : `${adminApi}/`;
  let url = "";
  if (eventId) {
    url = `${baseUrl}api/v3/event-configs/fetch-theme/${eventId}`;
  } else {
    url = `${baseUrl}api/v3/organizations/fetch-theme/`;
  }
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem(LOCAL_STORAGE_KEYS.token)}`,
      },
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch theme: ${res.status} ${res.statusText}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    // Return default theming data on error
    console.error("Failed to fetch event theme:", error);
    return {
      icons_filled: false,
      icon_style: "regular",
      borders_rounded: true,
      font_family: "Founders Grotesk",
      light_logo: "",
      dark_logo: "",
      favicon: "",
      system_placeholder: "",
      custom_css_file_url: "",
      custom_js_file_url: "",
      assets: {
        login_background: "",
        choices_background: "",
        all_done_background: "",
        placeholder: "",
        dark_avatar: "",
        avatar: "",
      },
      logos: {
        favicon: "",
        logo_dark: "",
        logo_light: "",
      },
    };
  }
};

